var _excluded = ["as", "align", "children", "classes", "gutterBottom", "italic", "transform"];
var _templateObject, _templateObject2, _templateObject3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import MuiTypography from '@material-ui/core/Typography';
export var StyledText = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var italic = _ref.italic,
    transform = _ref.transform,
    theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    text-transform: ", ";\n    ", "\n  "])), transform, italic && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      font-style: italic;\n    "]))));
});
function Heading(_ref2) {
  var as = _ref2.as,
    align = _ref2.align,
    children = _ref2.children,
    classes = _ref2.classes,
    gutterBottom = _ref2.gutterBottom,
    italic = _ref2.italic,
    transform = _ref2.transform,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(MuiTypography, _extends({
    component: as,
    variant: as,
    gutterBottom: gutterBottom,
    className: classes,
    align: align
  }, rest), /*#__PURE__*/React.createElement(StyledText, {
    italic: italic,
    transform: transform
  }, children));
}
Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Defines the alignment of text
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
  /**
   * HTML tag to render as
   */
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  /**
   * The content of the component. React component, node, text etc.
   */
  children: PropTypes.node.isRequired,
  /**
   * Defines the color of the component.
   * Supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  /**
   * Extend the classes to creates extra styles of the component.
   */
  classes: PropTypes.string,
  /**
   * Adds bottom margin
   */
  gutterBottom: PropTypes.bool,
  /**
   * Make font appearence italic
   */
  italic: PropTypes.bool,
  /**
   * Defines the capitalization of text.
   */
  transform: PropTypes.oneOf(['none', 'capitalize', 'lowercase', 'uppercase'])
} : {};
Heading.defaultProps = {
  align: 'left',
  color: 'textPrimary',
  classes: '',
  gutterBottom: true,
  italic: false,
  transform: 'none'
};
export default Heading;